// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-effectiveness-consultant-container {
  padding: 20px;
  max-width: 100%;
  margin: 0 auto;
}

.resource-effectiveness-header {
  margin-bottom: 30px;
  text-align: center;
}

.resource-effectiveness-header h1 {
  color: var(--text-strong);
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.resource-effectiveness-header p {
  color: var(--text-muted);
  font-size: 1.1rem;
  margin-bottom: 0;
}

.consultant-section {
  background: var(--surface);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  overflow: hidden;
  border: 1px solid var(--border);
}

/* Responsive design */
@media (max-width: 768px) {
  .resource-effectiveness-consultant-container {
    padding: 12px;
  }

  .resource-effectiveness-header {
    margin-bottom: 16px;
    text-align: left;
  }

  .resource-effectiveness-header h1 {
    font-size: 1.375rem;
  }

  .resource-effectiveness-header p {
    font-size: 0.9375rem;
  }

  .consultant-section {
    border-radius: 10px;
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/resource-effectiveness-consultant/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;AACF","sourcesContent":[".resource-effectiveness-consultant-container {\n  padding: 20px;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.resource-effectiveness-header {\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.resource-effectiveness-header h1 {\n  color: var(--text-strong);\n  font-size: 2.2rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.resource-effectiveness-header p {\n  color: var(--text-muted);\n  font-size: 1.1rem;\n  margin-bottom: 0;\n}\n\n.consultant-section {\n  background: var(--surface);\n  border-radius: 12px;\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n  border: 1px solid var(--border);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .resource-effectiveness-consultant-container {\n    padding: 12px;\n  }\n\n  .resource-effectiveness-header {\n    margin-bottom: 16px;\n    text-align: left;\n  }\n\n  .resource-effectiveness-header h1 {\n    font-size: 1.375rem;\n  }\n\n  .resource-effectiveness-header p {\n    font-size: 0.9375rem;\n  }\n\n  .consultant-section {\n    border-radius: 10px;\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
